import { render, staticRenderFns } from "./config-editor.vue?vue&type=template&id=6860134a&scoped=true"
import script from "./config-editor.vue?vue&type=script&lang=js"
export * from "./config-editor.vue?vue&type=script&lang=js"
import style0 from "./config-editor.vue?vue&type=style&index=0&id=6860134a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6860134a",
  null
  
)

export default component.exports